import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IEconomicActivity, IEconomicActivityDropdown, IEconomicActivityState } from "../../../types/economicActivity/economicActivityInterfaces";

export const initialState: IEconomicActivityState = {
    economicActivities: [],
    economicActivitiesDropdown: [],
    economicActivitySelected: null,
};

export const economicActivitySlice = createSlice({
    name: "economicActivities",
    initialState,
    reducers: {
        /**
         * Cargar todas las actividades económicas.
         */
        loadingEconomicActivities: (state, action: PayloadAction<IEconomicActivity[]>) => {
            state.economicActivities = action.payload;
        },

        /**
         * Cargar actividades económicas para el dropdown.
         */
        loadingEconomicActivitiesDropdown: (state, action: PayloadAction<IEconomicActivityDropdown[]>) => {
            state.economicActivitiesDropdown = action.payload;
        },

        /**
         * Activar o desactivar una actividad económica.
         */
        deactivateStateEconomicActivity: (state, action: PayloadAction<{ id: number; status: boolean }>) => {
            const { id, status: newState } = action.payload;
            state.economicActivities = state.economicActivities.map((activity) =>
                activity.id === id ? { ...activity, status: newState } : activity
            );
        },

        /**
         * Agregar una nueva actividad económica al estado global.
         */
        addEconomicActivity: (state, action: PayloadAction<IEconomicActivity>) => {
            state.economicActivities = [...state.economicActivities, action.payload];
        },

        /**
         * Actualizar una actividad económica.
         */
        updateEconomicActivity: (state, action: PayloadAction<IEconomicActivity>) => {
            state.economicActivities = state.economicActivities.map((activity) =>
                activity.id === action.payload.id ? { ...activity, ...action.payload } : activity
            );
        },
    },
});

export const {
    loadingEconomicActivities,
    loadingEconomicActivitiesDropdown,
    deactivateStateEconomicActivity,
    addEconomicActivity,
    updateEconomicActivity,
} = economicActivitySlice.actions;

export default economicActivitySlice.reducer;
